import styled from 'styled-components';
import { isDefined } from '../../helpers/utils';

const getModalWidth = (modalWidth) =>
  typeof modalWidth === 'number' ? `${modalWidth}px` : modalWidth;

const ModalWrapper = styled.div((props) => {
  const { contextTheme } = props;

  const bgColor = contextTheme ? '#3B4E5E' : 'white';

  /* eslint-disable indent */
  return `
        display: flex;
        align-items: center;
        background: ${bgColor};
        position: fixed;
        left: ${props.positionX}px;
        border-radius: 8px;
        z-index: 99;
        box-shadow: 4px 2px 6px;
        overflow: hidden
        width: ${getModalWidth(props.modalWidth)};
        min-height: 50px;
        cursor: default;
        border: 1px solid ${bgColor};
        ${
          props.modalBottom
            ? `bottom: ${props.modalBottom}px;`
            : `top: ${props.positionY}px`
        }
        ${
          props.positionArrowReverse
            ? ``
            : `::before {
                    width: 0; 
                    height: 0; 
                    border-left: 8px solid transparent;
                    border-right: 8px solid transparent;        
                    border-bottom: 15px solid ${bgColor};
                    position: fixed;
                    top: ${props.positionY - 10}px;
                    left: ${props.positionArrow - 8}px;
                    content: ' ';
                }`
        }
        ${
          props.leftAlign
            ? `::after {
              width: 0; 
              height: 0; 
              border-left: 8px solid transparent;
              border-right: 8px solid transparent;        
              border-bottom: 15px solid ${bgColor};
              position: fixed;
              top: ${props.positionArrowY}px;
              left: ${props.positionArrow}px;
              content: ' ';
              transform: ${
                isDefined(props.transform) ? 'rotate(-90deg)' : 'none'
              }`
            : ``
        }
        `;

  /* eslint-enable indent */
});

const Content = styled.div`
  flex-direction: column;
  width: 100%;
`;

const ContentTheme = styled.div`
  flex-direction: column;
  width: 100%;
  padding: 10px;
  color: white;
`;

export { ModalWrapper, Content, ContentTheme };



// WEBPACK FOOTER //
// ./components/context-modal/styled.js